/**
 * Created by Arif Topcu in 2019
 */

import React, { memo, useCallback } from "react";
import PropTypes from "prop-types";
import styles from "./FilterSummary.module.css";
import Button from "@ls/react-button";
import Icon from "react-icons-kit";
import { ic_remove_circle_outline } from "react-icons-kit/md/ic_remove_circle_outline";
import { ic_add } from "react-icons-kit/md/ic_add";

const FilterSummaryDetail = ({ deleteFilter, filterDef, idx }) => {
  const { includeExclude, level, values, key } = filterDef;
  const onDeleteFilter = useCallback(
    () => deleteFilter(filterDef),
    [filterDef, deleteFilter]
  );
  return (
    <div className={styles.summary} key={key + idx}>
      <div className={styles.info}>
        <div className={styles.deleteButton}>
          <Button
            icon={<Icon icon={ic_remove_circle_outline} size={18} />}
            variation={6}
            size="S"
            onButtonClick={onDeleteFilter}
          />
        </div>
        <div className={styles.level}>{level}</div>
        <div
          className={[
            styles.includeExclude,
            includeExclude === "INCLUDE" ? styles.green : styles.red,
          ].join(" ")}
        >
          {includeExclude}
        </div>
      </div>
      <div className={styles.values}>{values.join(", ")}</div>
    </div>
  );
};

const FilterSummary = ({
  filterDefinitions,
  setFiltersActive,
  deleteFilter,
}) => {
  return (
    <div className={styles.root}>
      {filterDefinitions.map((filterDef, idx) => (
        <FilterSummaryDetail
          filterDef={filterDef}
          idx={idx}
          deleteFilter={deleteFilter}
          key={filterDef.key + idx}
        />
      ))}
      <div
        className={styles.addMoreButton}
        onClick={() => setFiltersActive(true)}
      >
        <Icon icon={ic_add} style={{ display: "flex", alignItems: "center" }} />
        <div>Add Filter</div>
      </div>
    </div>
  );
};

FilterSummary.propTypes = {
  filterDefinitions: PropTypes.array.isRequired,
  setFiltersActive: PropTypes.func.isRequired,
  deleteFilter: PropTypes.func.isRequired,
};

export default memo(FilterSummary);
